<template >
<div class="container-fluid" v-if="lesson">
   
   <div class="row">
     <div class="col-md-8 col-sm-12">
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-success btn-block btn-lg" @click="_addTopic">
          Анги нэмэх
        </button>
      </div>

    </div>
    <hr/>
      <div class="card mb-4" v-for="(group) in lesson.groups"  v-if="lesson.groups && lesson.groups.length>0">
        <div class="card-header py-3">
          <div class="row">
            <div class="col col-expand">
              <h3 class="m-0 font-weight-bold text-primary">{{group.schoolName}}</h3>
            </div>
            <div class="col">
              <button type="button" class="btn btn-info btn-block btn-md" @click="$router.push({'name':'LessonGroupStudents', params:{ lessonId:lesson.id, groupId: group.program.id }})">
                Ирц
              </button>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <p class="m-0 font-weight-bold text-primary">{{group.schoolName}} - {{group.departmentName}} - {{group.programName}}</p>

        </div>
      </div>
      <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
      <hr class="mb-5"/>
      

      <div class="card shadow mb-4">
          
        <div class="card-header py-3">
          <div class="row">
            <div class='col'>
              <h4>Xичээл үзэж байгаа сурагчид</h4>
            </div>
 
          </div>
          <button class="btn btn-danger btn-sm" @click="$router.push({ name: 'LessonStudent', params: { lessonId: lesson.id} })" >Сурагч нэмэх</button>

        </div>
        <div class="card-body">
  
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="tmpStudents!=null && tmpStudents.length>0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Овог/Нэр</th>
                  <th>Сурагч код</th>
                  <th>Регистр</th>
                  <th>Төлөв</th>
                  <th>Үйлдэл</th>

                </tr>
              </thead>

              <tbody>
                <tr v-for="(std, index) in tmpStudents" v-bind:key="std.id">
                  <td>{{index+1}}</td>
                  <td><span v-if="std.student!=null">{{std.student.lastname}}/{{std.student.name}}</span></td>
                  <td><span v-if="std.student!=null">{{std.student.code}}</span></td>
                  <td><span v-if="std.student!=null">{{std.student.register}}</span></td>
                  <td>
                    <span v-if="std.enabled==true" class="badge badge-pill badge-success">идэвхтэй</span>
                    <span v-else class="badge badge-pill badge-danger">блоклосон</span>
                  </td>
                  <td>

                    <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                    <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button>
                    <button v-else class='btn btn-sm btn-primary mx-1' @click="setEnabledForStudent(std, true)">эрх нээх</button>
                  </td>
                </tr>
                
              </tbody>
            </table>
            <div v-else class="alert alert-info text-center">
                Одоогоор энэ хичээлийг үзэж байгаа cурагч байхгүй байна.
            </div>
        </div>

      </div>
      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Анги нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Сургууль:</label>
                      <select class="form-control" v-model="school" @change="schoolChanged">
                        <option v-for="(school, index) in schools" v-bind:key="school.id" v-bind:value="school">{{index+1}}.  {{school.data().name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col" v-if="school!=null">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Анги:</label>
                      <select class="form-control" v-model="department" >
                        <option v-for="(dep, index) in school.departments" v-bind:key="dep.id" v-bind:value="dep">{{index+1}}.  {{dep.data().name}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group" v-if="department!=null">
                  <label for="exampleFormControlSelect1">Бүлэг:</label>
                  <select class="form-control" v-model="program" >
                    <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{index+1}}.  {{pro.data().name}}</option>
                  </select>
                </div>
          
         
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="_addProgram" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>

     </div>
     <div class="col-md-4 col-sm-12">
        <div class="col-lg-12">
                <div class="card shadow mb-4">
                  <div class="card-header">
                    <h4>{{lesson.name}}</h4>
                  </div>
                  <div class="card-body">
                    <h4 class="mb-1">Үнэ:
                      <span class='badge badge-success' v-if="lesson.price==null || lesson.price==undefined || lesson.price==0">Free</span>
                      <div v-else>
                        <span class='badge badge-info'>
                          {{lesson.price}}
                          
                        </span>
                      </div>
                    </h4>
                    <button v-if='lesson.price!=null && lesson.price!=undefined && lesson.price>0' class="btn btn-secondary btn-sm">      
                      <router-link :to="{ name: 'LessonPayment', params: { lessonId: lesson.id}}" class="text-white">Төлбөрийн мэдээлэл</router-link>
                    </button>
                    <p>{{lesson.description}}</p>
                    <div class="btn btn-info btn-sm">
                      <router-link :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}" class="text-white">Хичээлийн мэдээлэл засах</router-link>
                    </div>
                    <div class="btn btn-default  btn-sm mx-1 my-2">
                      <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}">Хичээлийн зураг оруулах</router-link>
                    </div>
                    <br/>

                    <br/>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <button class="btn btn-outline-secondary btn-sm" type="button" v-for="type in lesson.types">
                          {{type}}

                        </button>

                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card shadow mb-4">
                  <div class="card-header">
                    <h4>Мэдээлэл</h4>
                  </div>
                  <div class="card-body">
                    <p style="margin-bottom: 0rem;">Багш:<span style="font-weight:bold">{{lesson.profession}}</span></p>
                    <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
                     <vue-qrcode v-if="lesson" :value="lesson.lectureCode.toString()" />
                    <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
                    <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p>
                  </div>
                </div>
              </div>
      


     </div>
   </div>
</div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode'
export default {
    name: "LessonDetail",

    data() {
        return {
            lesson: null,
            topic:{
              'name':null,
              'description':null,
              'price':0,
              'tags':[],
              'shortname':null
            },
            content:{
              'name':null,
              'description':null,
              'videoUrl':null,
              'published':false,
              'startDay':null,
              'endDay':null,
              'code':null,
              'duration':null,
              'shortname':null
            },
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
            tmpAdditionalFile:{
              'name':'',
              'uploading':false,
              'uploadPercent':null
              
            },
            lessonBucket:'lessonFiles/',
            topicBucket:'lessonTopicFiles/',
            display:0,
            tagText:null,
            schools:[],
            school:null,
            department:null,
            program:null,
            
        };
    },
    methods: {
        
      _getQA(){
          fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
              let lesson=doc.data();
              lesson.id=doc.id;
              this.lesson=lesson;
            
          });

          fb.db.collection("lessons/"+this.lessonId+'/studentList').onSnapshot(querySnapshot=> {
              this.tmpStudents=[]
              querySnapshot.forEach(stddata=> {
                let object=stddata.data()
                object.id = stddata.id;
                object.student=null;
                object.ref=stddata.ref;
                if(stddata.data().studentRef!=null){
                  stddata.data().studentRef.get().then(studentDoc=>{
                    object.student=studentDoc.data();

                  });
                }
                this.tmpStudents.push(object);
              });
            
          });

 

      },

      saveTopic() {
          if(this.lesson!=null && this.topic!=null && this.topic.name!='' && this.topic.description!=''){
            if(this.topic.price!=null && this.topic.price=='')
              this.topic.price=0;
              if(this.topic.id!=null && this.topic.id!='' && this.topic.id!='new'){
                this.topic.modifiedAt=new Date()
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).update(this.topic)
              }
              else{
                var now=new Date();
                this.topic.createdAt=now;
                
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc().set(this.topic)
                fb.db.collection("lessons").doc(this.lessonId).update({
                  'numberOfTopics':fb.firestore.FieldValue.increment(1)
                })
              }
              this.topic={
                'name':null,
                'description':null,
                'price':0,
                'tags':[],
                'shortname':null
              }

          }
      },



      addStudents(){
        if(this.studentsText!=null && this.studentsText!=''){

          var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
          arrayOfLines.forEach(value=>{
            // console.log(value);
            var lineArray=value.split(/\s+/);
            console.log(lineArray)
            if(lineArray!=null && lineArray.length==2 && lineArray[0]!=null && lineArray[0]!='' && lineArray[1]!=null && lineArray[1]!=''){
              var lessonRef= fb.db.collection("lessons").doc(this.lessonId);
              var studentRef=fb.db.collection("students").doc(lineArray[0].toLowerCase()).get().then(studentData=>{
                var studentDetail;
                var saveStudent=true;
                if(studentData!=null && studentData.exists){
                  // studentData.ref.update({
                    // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef)
                  // });
                  studentDetail=studentData.data();
                  this.addStudentToLesson(lessonRef, studentData, studentDetail);
                }
                else{
                  fb.db.collection("students").where("register", "==", lineArray[1].toLowerCase()).get().then(value=>{
                    if(value.empty)
                    {
                      studentDetail={
                        'code':lineArray[0].toLowerCase(),
                        'register': lineArray[1].toLowerCase(),
                        // 'lessons': fb.firestore.FieldValue.arrayUnion(lessonRef),
                        'created': fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                        'createdAt': new Date()
                      };
                      studentData.ref.set(
                        studentDetail
                      );
                      this.addStudentToLesson(lessonRef, studentData, studentDetail);
                    }
                  });
              
                }
                
              });

            }
          });
          this.studentsText=''
        }
      },
      addStudentToLesson(lessonRef, studentData, studentDetail){
        studentData.ref.collection("lessonList").doc(lessonRef.id).get().then(stLesson=>{
          if(stLesson!=null && stLesson.exists){

          }
          else{
            studentData.ref.collection("lessonList").doc(lessonRef.id).set({
              lessonRef: lessonRef,
              addedDate: new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
        
        lessonRef.collection("studentList").doc(studentData.id).get().then(lessonSt=>{
          if(lessonSt!=null && lessonSt.exists){

          }
          else{
            lessonRef.update({
              'numberOfStudents': fb.firestore.FieldValue.increment(1)
            });
            lessonRef.collection("studentList").doc(studentData.id).set({
              addedDate:new Date(),
              addedUser: fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              studentRef: studentData.ref,
              enabled:true,
              semester: this.lesson.semester
            })
          }
        });
      },
      _addTopic(){
        this.school=null;
        this.department=null;
        this.program=null;
        $('#exampleModal').modal('toggle');
      },
      
      _deleteLessonFile(file, index){
        var result = confirm("Та "+file.title+" файлыг устгах уу?");
          if (result) {
            var fileName=file.uploadedAt.toDate().getTime()+"_"+file.fileName;
            var fileRef = fb.storageRef.child(this.lessonBucket+ fileName);
            // Delete the file
            fileRef.delete().then(() =>{
              this.lesson.files.splice(index, 1)
              fb.db.collection("lessons").doc(this.lessonId).update({
                  files: this.lesson.files
                }
              )
            }).catch(function(error) {

            });
              
          }
      },
      setEnabledForStudent(stddata, value){
        this.setProperty("enabled", stddata.ref, value);
        this.setProperty("enabled", fb.db.doc("students/"+stddata.id+"/lessonList/"+this.lessonId), value);
        
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      removeStudent(stddata){
        fb.db.doc("students/"+stddata.id+"/lessonList/"+this.lessonId).delete();
        stddata.ref.delete();
        fb.db.collection("lessons").doc(this.lessonId).update({
          'numberOfStudents': fb.firestore.FieldValue.increment(-1)
        });

      },
      setPublished(value, lesson){

      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      _getSchools(){
          fb.db.collection("schools")
          .get()
          .then(querySnapshot=> {
              querySnapshot.forEach(schoolData=> {
                
                this._getDepartments(schoolData.id, schoolData);
                this.schools.push(schoolData);


              });
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getDepartments(schoolId, schoolData){
          schoolData.ref.collection("departments")
          .get()
          .then(querySnapshot=> {
              let deps=[]
              querySnapshot.forEach(depdata=> {
                this._getPros(depdata)
                deps.push(depdata);

                // fb.db.collection("lessons").where("department", "==", depdata.ref).get().then(values=>{
                //   depdata.ref.update({"numberOfLessons": values.size});
                // });

                // fb.db.collection("lessons").where("department", "==", depdata.ref).where("published","==", true).get().then(values=>{
                //   depdata.ref.update({"publishedLesson": values.size});
                // });

              });
              schoolData.departments=deps;


            
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        _getPros(depdata){
          depdata.ref.collection("programs")
          .get()
          .then(querySnapshot=> {
            let pros=[]
              querySnapshot.forEach(prodata=> {
                pros.push(prodata);
                // fb.db.collection("lessons").where("program", "==", prodata.ref).get().then(values=>{
                //   prodata.ref.update({"numberOfLessons": values.size});
                // });

                // fb.db.collection("lessons").where("program", "==", depdata.ref).where("published","==", true).get().then(values=>{
                //   prodata.ref.update({"publishedLesson": values.size});
                // });
              });
              depdata.programs=pros;

              
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        schoolChanged(){
          this.department=null
          this.program=null
        },
        _addProgram(){
          if(this.school!=null && this.school!=undefined && this.department!=null && this.department!=undefined && this.program!=null && this.program!=undefined){
            console.log(this.school.data());
            console.log(this.department.data());
            console.log(this.program.data());
            var exists=false;
            if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups!=null && this.lesson.groups!=undefined && this.lesson.groups.length>0){
              for(const tmp of this.lesson.groups){
                if(tmp!=null && tmp!=undefined && tmp.program!=null && tmp.program!=undefined && tmp.program.id==this.program.id){
                  exists=true;
                }
              }
            }
            if(exists==false){
              fb.db.collection("lessons").doc(this.lesson.id).update({
                groups: fb.firestore.FieldValue.arrayUnion(
                  {
                    school: this.school.ref,
                    department: this.department.ref,
                    program: this.program.ref,
                    schoolName: this.school.data().name,
                    departmentName: this.department.data().name,
                    programName: this.program.data().name
                  }
                )
              });
              this.findStudents(this.school.ref, this.department.ref, this.program.ref);
            }
            else{
              alert("Аль хэдийн нэмэгдсэн байна.");
            }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        findStudents(sc, dep, pro){
          fb.db.collection("students").where("school", "==", sc).where("department", "==", dep).where("program", "==", pro).get().then(docs=>{
            for(const studentData of docs.docs){
              
              if(studentData!=null && studentData.exists){
                var studentDetail=studentData.data();
                this.addStudentToLesson(fb.db.collection("lessons").doc(this.lesson.id), studentData, studentDetail);
              }
            }
          });
        }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
    },
    props: {
        lessonId: { 
            required: true,
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
          this._getSchools();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

